import { styled } from '@mui/material';
import type { PartNode } from '@partful/shared-types';
import { useTranslation } from 'react-i18next';
import { filterCustomAttributesToShow } from 'src/components/Product/Shared/Helpers/filterCustomAttributesToShow';
import { PaddedBlock } from '../../styles';
import { AttributeList } from './AttributeList';

interface OverviewTabProps {
  current: PartNode;
}

const NoInformation = styled('p')`
  text-align: center;
  margin-top: 2rem;
`;

export default function OverviewTab({ current: { attributes } }: OverviewTabProps) {
  const { t } = useTranslation('partsCatalogue');
  const attributesWithoutEmptyFields = filterCustomAttributesToShow(attributes);

  if (!attributesWithoutEmptyFields || /* istanbul ignore next */ !Object.keys(attributesWithoutEmptyFields).length) {
    return <NoInformation>{t('noFurtherInfoToDisplay')}</NoInformation>;
  }
  /* istanbul ignore next */
  return (
    <PaddedBlock>
      <AttributeList attributes={attributesWithoutEmptyFields} />
    </PaddedBlock>
  );
}
